import { LabelConfigProjector } from '@protocols/domain';
import { LabelConfigRepository } from '@telespot/domain';

export interface ListMethodTypeLabelColorsInput {
  methodTypeId: string;
}

export interface ListMethodTypeLabelColorsOutput {
  labelUuid: string;
  /** Stored colour including alpha. */
  color: string;
}

export interface IListMethodTypeLabelColorsQuery {
  /**
   * Lists the colour each label carries on the given method type, in one
   * roundtrip. Rows are not paginated — the set is pre-filtered to one method
   * type. Repository errors propagate so the caller can degrade gracefully.
   */
  execute(input: ListMethodTypeLabelColorsInput): Promise<ListMethodTypeLabelColorsOutput[]>;
}

export class ListMethodTypeLabelColorsQuery implements IListMethodTypeLabelColorsQuery {
  constructor(private readonly labelConfigRepository: LabelConfigRepository) {}

  public async execute(input: ListMethodTypeLabelColorsInput): Promise<ListMethodTypeLabelColorsOutput[]> {
    const configs = await this.labelConfigRepository.findByMethodType(input.methodTypeId);

    // A (label, methodType) pair should hold at most one config; where duplicates
    // exist, the projector owns which one is authoritative.
    const colorsByLabelUuid = LabelConfigProjector.colorsByLabel(configs);

    return Array.from(colorsByLabelUuid, ([labelUuid, color]) => ({ labelUuid, color }));
  }
}
